<template>
    <div
        class="m-promoGroup promo-group d-flex flex-column"
        :class="{
            all: isWalkThroughActive && group.acceptance === 'all',
            any: isWalkThroughActive && group.acceptance === 'any'
        }"
    >
        <div class="m-promoGroup__header">
            <h2 class="h3 mb-0">
                {{ group.name }}
                <span v-if="group.pagination" class="m-promoGroup__header-counter h4">
                    ({{ group.pagination.totalRecords }})
                </span>
                <a-icon
                    v-if="group.acceptance === 'all'"
                    v-tooltip="padlockTooltip"
                    class="ml-2 text-warning"
                    icon="PadlockDown"
                />
            </h2>
            <div class="d-flex">
                <the-btn
                    v-if="group.attachments"
                    class="btn-custom-gray px-3"
                    :class="{ 'py-0': showAcceptButton }"
                    v-tooltip="'Pobierz materiały do grupy promocji'"
                    @click.native="openGroupAttachmentsModal"
                >
                    <a-icon icon="DownloadAttachment" width="24px" />
                </the-btn>
                <div
                    v-if="showAcceptButton"
                    v-tooltip="{
                        content: group.groupButtonTooltipInfo
                    }"
                    class="pl-4"
                >
                    <the-btn
                        @click.native="selectGroup"
                        class="btn-custom-gray"
                        :class="isSelected ? 'active' : ''"
                        :id="
                            `${isSelected ? 'remove-from' : 'add-to'}-card-${
                                this.$route.name === 'labels'
                                    ? 'label'
                                    : 'promo'
                            }-group`
                        "
                        :disabled="isGroupButtonDisabled"
                    >
                        {{ isSelected ? groupAddedText : addGroupText }}
                        <a-icon
                            class="ml-2"
                            :icon="groupButtonIcon"
                            height="18px"
                            width="18px"
                        />
                    </the-btn>
                </div>
            </div>
        </div>
        <div class="m-promoGroup__promos" role="promos">
            <promotions-list
                v-if="group.promos && group.promos.length"
                :promotions="group.promos"
                :preview-type="previewTypeValue"
                :group-id="group.id"
                :acceptance="group.acceptance"
            />

            <page-preloader
                v-if="isLoadMoreLoader || group.promosStatus === 'loading'"
                min-height="100px"
            />

            <p
                v-if="
                    group.promosStatus === 'idle' &&
                        (!group.promos || !group.promos.length)
                "
                class="mb-0"
            >
                Brak promocji w grupie
            </p>
        </div>

        <div
            v-if="group.pagination && group.pagination.nextPage"
            class="m-promoGroup__footer mt-3"
        >
            <the-btn
                class="btn-custom-gray w-100"
                @click.native="loadMorePromos"
            >
                Pokaż kolejne promocje z grupy
            </the-btn>
        </div>
        <div
            v-if="group.promos && group.promos.length > 2"
            role="collapse"
            class="btn-collapse w-100 mt-3 mx-auto d-flex align-items-center"
        >
            <the-btn
                class="btn-custom-gray w-100"
                @click.native="collapseGroup"
            >
                Zwiń grupę
            </the-btn>
        </div>
    </div>
</template>

<script>
import PromotionsList from '@/components/promotions/PromotionsList'
import { btnCollapse } from '@/mixins/btnCollapse'

export default {
    name: 'PromoGroup',
    mixins: [btnCollapse],
    data() {
        return {
            isLoadMoreLoader: false,
            isSelectLoader: false,
            padlockTooltip: `
                <div class="p-2">
                    <h6 class="mb-1">Grupa zamknięta</h6>
                    <span>Wymaga aktywacji wszystkich promocji, które wchodzą w jej skład.</span>
                </div>
            `
        }
    },
    props: {
        group: {
            type: Object,
            required: true
        },
        previewType: {
            type: String,
            required: false
        }
    },
    components: {
        PromotionsList
    },
    computed: {
        isWalkThroughActive() {
            return this.$store.getters.getWalkthroughActive
        },
        arePromoFiltersApplied() {
            return this.$store.getters.arePromoFiltersApplied(
                'getPromotionsFilters'
            )
        },
        areLabelFiltersApplied() {
            return this.$store.getters.arePromoFiltersApplied(
                'getLabelGroupsFilters'
            )
        },
        groupAddedText() {
            if (this.$route.name === 'labels') {
                if (this.areLabelFiltersApplied) {
                    return 'Dodano wybrane'
                } else {
                    return 'Dodano grupę'
                }
            } else {
                if (
                    this.$store.getters.arePromoFiltersApplied &&
                    this.group.acceptance === 'any'
                ) {
                    return 'Dodano wybrane do aktywacji'
                } else {
                    return 'Dodano grupę do aktywacji'
                }
            }
        },
        addGroupText() {
            if (this.$route.name === 'labels') {
                if (this.areLabelFiltersApplied) {
                    return 'Dodaj wybrane'
                }

                return 'Dodaj grupę'
            }

            if (
                this.arePromoFiltersApplied &&
                    this.group.acceptance === 'any'
            ) {
                return 'Dodaj wybrane do aktywacji'
            }

            return 'Dodaj grupę do aktywacji'
        },
        previewTypeValue() {
            return this.previewType || this.$route.name
        },
        showAcceptButton() {
            if (!(this.group.promos || []).length) {
                // Don't show accept button if there are no promos
                return false
            }

            if (this.$route.name === 'labels') {
                // Show accept button for labels
                return true
            }

            // Promos
            if (!this.isPromoEditPermission) {
                // Shop user cannot manage promos
                return false
            }

            return (
                // Show accept button on promo-list and promo-later
                this.$route.name === 'promo-list' ||
                this.$route.name === 'promo-later'
            )
        },
        isSelected() {
            let getGroup = false
            if (this.$route.name === 'labels') {
                getGroup = this.$store.getters.getSelectedLabelGroup(
                    this.group.id
                )
            } else {
                getGroup = this.$store.getters.getSelectedPromoGroup(
                    this.group.id
                )
            }

            return getGroup && getGroup.selectWholeGroup
        },
        isPromoEditPermission() {
            return this.$store.getters.isPromoEditPermission
        },
        groupButtonIcon() {
            if (this.isButtonLoader) {
                return 'Spinner'
            } else if (this.isSelected) {
                return 'Approval'
            } else {
                return 'Plus'
            }
        },
        isButtonLoader() {
            return (
                (this.group.status === 'loading' &&
                    this.group.loadingSelectedPromoIds) ||
                this.isSelectLoader
            )
        },
        selectedGroups() {
            if (this.$route.name === 'labels') {
                return this.$store.getters.getSelectedLabelGroups
            } else {
                return this.$store.getters.getSelectedPromoGroups
            }
        },
        isGroupButtonDisabled() {
            let areProductsLoading = false
            if (
                this.previewTypeValue === 'promo-labels' ||
                this.previewTypeValue === 'labels'
            ) {
                if (
                    this.group.promos.some(
                        promo => promo.productsStatus === 'loading'
                    ) ||
                    this.group.promos.some(promo => !promo.totalProductsRecords)
                ) {
                    areProductsLoading = true
                }
            }

            return (
                !this.group.selectWholeGroupButtonEnable ||
                this.group.loadingSelectedPromoIds ||
                areProductsLoading
            )
        }
    },
    methods: {
        async loadMorePromos() {
            const { $store, group, previewTypeValue: preview } = this
            const { big } = $store.getters.getPromoGroupsPromosLoad
            const { perPage, page, nextPage } = group.pagination

            this.isLoadMoreLoader = true

            const payload = {
                group,
                per: big,
                // When we change per to big, we need to reset page to 1
                page: +perPage !== big && +page === 1 ? 1 : nextPage
            }

            if (preview === 'promo-labels' || preview === 'labels') {
                // Fetch labels
                await $store.dispatch('fetchLabelsPromosByPromoGroup', payload)
            } else {
                // Fetch promos
                await $store.dispatch('loadPromosByPromoGroup', payload)
            }
            this.isLoadMoreLoader = false
        },
        async selectGroup() {
            if (this.isButtonLoader || this.isWalkThroughActive) return
            const payload = {
                groupId: this.group.id,
                select: !this.isSelected
            }

            if (
                this.previewTypeValue === 'promo-labels' ||
                this.previewTypeValue === 'labels'
            ) {
                this.isSelectLoader = true
                await this.$store.dispatch('selectLabelPromoGroup', payload)
                this.isSelectLoader = false
            } else {
                await this.$store.dispatch('selectPromoGroup', payload)
            }
        },
        openGroupAttachmentsModal() {
            this.$store.dispatch('openModal', {
                component: 'DownloadGroupAttachments',
                args: {
                    groupId: this.group.id,
                    name: this.group.name,
                    groupAttachments: this.group.attachments,
                    modalSize: 'modal-xl'
                }
            })
        },
        collapseGroup() {
            this.group.pagination = {
                ...this.group.pagination,
                nextPage: 2,
                prevPage: '',
                perPage: 2
            }
            this.group.promos = this.group.promos.slice(0, 2)

            const headerHeight = document.querySelector('.site-header')
                .clientHeight
            this.$scrollTo(this.$el, 100, {
                offset: -headerHeight - 16
            })
        },
        onHandleBtnCollapse() {
            if (this.group.promos && this.group.promos.length > 2) {
                this.handleBtnCollapse(this.$el)
            }
        }
    },
    mounted() {
        this.onHandleBtnCollapse()

        document.addEventListener('scroll', () => {
            this.onHandleBtnCollapse()
        })
    },
    watch: {
        selectedGroups() {
            this.onHandleBtnCollapse()
        },
        'group.promos.length'() {
            this.$nextTick(() => {
                this.onHandleBtnCollapse()
            })
        }
    }
}
</script>